<template>
	<div class="project__details">
		<div
			class="detail__accordions"
			v-for="(detail, index) in JSON.parse(details)"
			:key="index"
		>
			<project-details-child
				:title="detail.title"
				:description="detail.description"
			></project-details-child>
		</div>
	</div>
</template>

<script>
import ProjectDetailsChild from '../vue/ProjectDetailsChild.vue';

export default {
	data() {
		return {
			hello: 'World',
		};
	},

	props: {
		details: {},
	},

	computed: {},

	watch: {},

	methods: {},

	components: { ProjectDetailsChild },

	created() {},
	mounted() {},
};
</script>

<style lang="scss" scoped>
@import '../../styles/common/variables';

.project__details {
	margin-bottom: 50px;
}
</style>



// WEBPACK FOOTER //
// resources/assets/scripts/vue/ProjectDetails.vue